export default __webpack_public_path__ + "static/media/cp_geo_mc.c90e4df3.svg";